import { useRequest } from 'ahooks'
import { importConfig as importConfigSvc } from '@/services/api/resource'
import { useDispatch, useSelector } from '@/store'
import { setImportConfig } from '@/store/commonSlice'
import type { UploadRestrictItem, UploadRestrictListReq } from '@/services/api/resource/type'
import { omit } from 'lodash'
import type { UploadScene } from '@/constants/resource'

/**
 * uploadSizeLimit MB
 */
export const DefaultConfig = { sceneId: null, uploadSizeLimit: 10 }
/** 获取导入配置 */
export default () => {
  const dispatch = useDispatch()
  const importConfig = useSelector((state) => state.common.importConfig)

  const { run: getImportConfig, ...rest } = useRequest(
    (param = { bizModules: ['ONEWAREHOUSE'] } as UploadRestrictListReq) => {
      return importConfigSvc(param)
    },
    {
      manual: true,
      onSuccess(resp) {
        if (resp.code === 'SUCCESS') {
          dispatch(setImportConfig(resp.data?.restricts || []))
        }
      },
    }
  )

  const getConfigByScene = (scene: UploadScene) => {
    return importConfig?.[scene] || (DefaultConfig as UploadRestrictItem)
  }

  return {
    getImportConfig,
    getConfigByScene,
    ...omit(rest, 'data'),
  }
}
